import React from 'react';

const Tag: React.FC<{ tag: string }> = ({ tag }) => (
  <span className="Tag transition radius-sm text-sm inline-block bg-color-primary color-white mb_25 md:mb_5 py_25 px_75 mr_25 md:mr_5 text-mono">{tag}</span>
);

export default Tag;
